import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { CopyOutlined, ReloadOutlined } from '@ant-design/icons';
import { Modal, Switch } from 'antd';
import Input from '@views/Input';
import Button from '@views/Button';

import './InviteParticipants.css';

export const InviteParticipants = ({
  visible,
  saving,
  onCancel,
  isOpen = true,
  inviteCode,
  onRegenInviteCode,
  onSwitchOpen,
}) => {
  const codeInputRef = React.useRef(null);
  const [confirmRegen, setConfirmRegen] = React.useState(false);
  return (
    <Modal
      title="Invitar Participantes"
      visible={visible}
      confirmLoading={saving}
      onCancel={saving ? noop : onCancel}
      cancelText="Cerrar"
      destroyOnClose
      cancelButtonProps={{ className: 'mbutton mbutton-secondary' }}
      okButtonProps={{ style: { display: 'none' } }}
      className="InviteParticipants"
    >
      <div className="switch-container">
        <label htmlFor="isOpen">¿Permitir nuevos participantes?</label>
        <Switch
          checked={isOpen}
          name="isOpen"
          onChange={onSwitchOpen}
          disabled={saving}
        />
      </div>
      {isOpen ? (
        <div className="invite-body">
          <p>
            Comparte el siguiente enlace con tus amigos para que se puedan unir
            al torneo:
          </p>
          <div className="invite-container">
            <Input ref={codeInputRef} value={inviteCode || 'asdasdasdasd'} />
            <button
              title="Copiar al portapapeles"
              onClick={() => {
                if (codeInputRef.current) {
                  codeInputRef.current.input.select();
                  navigator.clipboard.writeText(
                    codeInputRef.current.input.value
                  );
                }
              }}
            >
              <CopyOutlined />
            </button>
          </div>
          <div className="regen-container">
            {confirmRegen ? (
              <div>
                <p className="danger">
                  Si generas un nuevo link de invitación, el link anterior ya no
                  funcionará. ¿Confirmas la operación?
                </p>
                <Button
                  type="link"
                  onClick={() => {
                    onRegenInviteCode();
                    setConfirmRegen(false);
                  }}
                >
                  Si, generar nuevo link
                </Button>
                <Button type="link" onClick={() => setConfirmRegen(false)}>
                  No, manener el link actual
                </Button>
              </div>
            ) : (
              <Button
                type="link"
                onClick={() => setConfirmRegen(true)}
                disabled={saving}
              >
                Generar nuevo link
                <ReloadOutlined />
              </Button>
            )}
          </div>
        </div>
      ) : (
        <p className="danger">
          Nadie podrá unirse al torneo mientras esté cerrado
        </p>
      )}
    </Modal>
  );
};

InviteParticipants.displayName = 'InviteParticipants';
InviteParticipants.propTypes = {
  visible: PropTypes.bool,
  saving: PropTypes.bool,
  onCancel: PropTypes.func,
  isOpen: PropTypes.bool,
  inviteCode: PropTypes.string,
  onRegenInviteCode: PropTypes.func,
  onSwitchOpen: PropTypes.func,
};

InviteParticipants.defaultProps = {
  visible: false,
  saving: false,
  onCancel: noop,
  isOpen: true,
  inviteCode: '',
  onRegenInviteCode: noop,
  onSwitchOpen: noop,
};

export default InviteParticipants;
